/*eslint no-template-curly-in-string: "off"*/
/*eslint sort-keys: "off"*/

const translates = {
  comment: 'Informations supplémentaires',
  contactName: 'Nom du contact',
  enterValidPsw: 'Entrez un mot de passe valide',
  helpUsKeepThisAccountSafe: 'Sécuriser votre compte',
  login: 'Se connecter',
  password: 'Mot de passe',
  menuFaq: 'FAQ',
  menuOrderTote: 'Commander des totes',
  body: 'Corps',
  emptySubjectOrBody: 'Veuillez indiquer le sujet et votre message',
  messageSent: 'Message envoyé ',
  subject: 'Objet',
  sendEmail: 'Envoyer',
  errorMsgTitle: 'Erreur',
  missingUuid: 'Informations sur l\'utilisateur manquantes',
  howWeCanHelp: 'Comment pouvons-nous vous aider ?',
  need_help: 'Toujours besoin d\'aide ?',
  loading: 'Chargement',
  loginFailed: 'Échec de connexion',
  loginFailedMessage: 'Veuillez réessayer',
  back: 'Retour ',
  backToStoreManagement: 'Retour à la rubrique Gestion magasins',
  succesMsgTitle: 'Commande envoyée !',
  success: 'Demande envoyée !',
  receivedInfoModification: 'Nous avons reçu votre demande de modification et nous vous contacterons.',
  receivedToteOrder: 'Votre commande de Tote a bien été reçue, vous recevrez un nouveau lot dans les prochains jours !',
  emailAddress: 'Adresse e-mail ',
  numberOfTotes: 'Nombre de totes',
  modificationRequestError: 'Erreur dans la demande',
  myInformationIsIncorrect: 'Mes informations sont incorrectes',
  orderRequestError: 'Erreur. Echec de la commande. Contactez le Service Client Loop à infomag@loopmobileapp.com',
  orderRequestSent: 'Commande envoyée',
  orderTotes: 'Commander des totes',
  phoneNumber: 'Numéro de téléphone ',
  phoneNumberUpdateError: 'Erreur de mise à jour',
  phoneNumberUpdateSuccess: 'Mise à jour réussie',
  pleaseConfirm: 'Veuillez confirmer les détails de votre commande',
  sendUsModification: 'Envoyez-nous une demande de modification',
  storeAddress: 'Adresse du magasin',
  menuContact: 'Contact',
  menuOrders: 'Historique des commandes de totes',
  ordersTitle: 'Historique des commandes de totes',
  noOrders: 'Aucune commande trouvée',
  status: 'Statut',
  statusNew: 'Nouveau',
  statusInProgress: 'En cours',
  statusDelivered: 'Livré',
  statusCancelled: 'Annulé',
  cardTitleNew: '{{quantity}} nouveaux totes commandés',
  cardTitleInProgress: '{{quantity}} totes en cours de traitement',
  cardTitleDelivered: '{{quantity}} totes livrés',
  cardTitleCancelled: 'Commande annulée',
  orderNumber: 'Numéro de commande',
  createdOn: 'Créé le',
  cancelledOn: 'Annulé le',
  trackingNumber: 'Numéro de suivi',
  clickToEdit: 'Cliquer pour modifier',
  loginError: ' Your token is expired or revoked. Please refresh the page',
}

export default translates

